import VideoPlayer from '../VideoPlayer';
import videoPlayerView from './videoPlayerPlaylistView.html';
import './videoPlayerPlaylistStyles.css';

export function videoPlayerPlaylistComponent() {
	return {
		bindings: {
			videos: '=',
			colors: '=',
			showTitle: '=?',
			volume: '=?',
		},
		controllerAs: 'vm',
		controller: videoPlayerComponentCtrl,
		template: videoPlayerView,
	};
}

class videoPlayerComponentCtrl {
	constructor($element, $timeout) {
		'ngInject';
		this.$timeout = $timeout;
		let container = $element[0].querySelector('.video-player-container');
		this.player = new VideoPlayer(container);
		this.beginPlaylist();
		this.setVolume();
	}

	beginPlaylist() {
		if (!this.videos) {
			return;
		}
		this.pos = 0;
		this.next();
	}

	next() {
		if (!this.videos || this.videos.length === 0) {
			return;
		}
		if (this.pos >= this.videos.length) {
			this.pos = 0;
		}
		this.titleColor = this.colors[this.pos % this.colors.length];
		this.$timeout(() => {
			let current = this.videos[this.pos++];
			// console.log('next!','pos=',this.pos-1, 'current=', current);
			// on video ended or video error, play next
			let next = () => {
				// console.log('videoPlayerPlaylistComponent next()');
				this.player.stop();
				this.next();
			};
			// play next video when done or on error
			this.player.play(current.url).then(next, () => {
				console.error('Video playback error! Video:', current);
				const idx = this.videos.indexOf(current);
				if (idx > -1) {
					this.videos.splice(idx, 1);
				}
				next();
			});
			this.title = current.name;
		});
	}

	setVolume() {
		// console.log('videoPlayerPlaylist setVolume attempt', this.volume, typeof this.volume, this.volume >= 0, this.volume <= 1);
		if (typeof this.volume == 'number' && this.volume >= 0 && this.volume <= 1) {
			// console.log('videoPlayerPlaylist setVolume success!', this.volume);
			this.player.setVolume(this.volume);
		}
	}
}
